import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  it: {
    translation: {
      nav: {
        services: "Servizi", functions: "Funzioni", stories: "Storie", pricing: "Prezzi",
        faq: "FAQ", demo: "Demo", login: "Accedi", register: "Inizia gratis",
      },
      hero: {
        cta_primary: "Prova gratis 14 giorni",
        cta_secondary: "Prova in 60 secondi",
      },
      common: {
        loading: "Caricamento…", save: "Salva", cancel: "Annulla", delete: "Elimina",
        confirm: "Conferma", close: "Chiudi", search: "Cerca", new: "Nuovo",
        edit: "Modifica", back: "Indietro", next: "Avanti", language: "Lingua",
      },
      portal: {
        dashboard: "Dashboard", checkin: "Timbratura", calendar: "Calendario",
        chat: "Chat", signatures: "Da firmare", files: "I miei file",
        payslips: "Cedolini", expenses: "Rimborsi", leaves: "Ferie/Permessi",
        premium: "Premium",
      },
    },
  },
  en: {
    translation: {
      nav: {
        services: "Services", functions: "Features", stories: "Stories", pricing: "Pricing",
        faq: "FAQ", demo: "Demo", login: "Log in", register: "Start free",
      },
      hero: {
        cta_primary: "Try 14 days free",
        cta_secondary: "Try in 60 seconds",
      },
      common: {
        loading: "Loading…", save: "Save", cancel: "Cancel", delete: "Delete",
        confirm: "Confirm", close: "Close", search: "Search", new: "New",
        edit: "Edit", back: "Back", next: "Next", language: "Language",
      },
      portal: {
        dashboard: "Dashboard", checkin: "Check-in", calendar: "Calendar",
        chat: "Chat", signatures: "To sign", files: "My files",
        payslips: "Payslips", expenses: "Expenses", leaves: "Leaves",
        premium: "Premium",
      },
    },
  },
  fr: {
    translation: {
      nav: { services: "Services", functions: "Fonctions", stories: "Témoignages", pricing: "Tarifs", faq: "FAQ", demo: "Démo", login: "Connexion", register: "Démarrer" },
      hero: { cta_primary: "Essai gratuit 14 jours", cta_secondary: "Essayer en 60s" },
      common: { loading: "Chargement…", save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", confirm: "Confirmer", close: "Fermer", search: "Rechercher", new: "Nouveau", edit: "Modifier", back: "Retour", next: "Suivant", language: "Langue" },
      portal: { dashboard: "Tableau de bord", checkin: "Pointage", calendar: "Calendrier", chat: "Chat", signatures: "À signer", files: "Mes fichiers", payslips: "Fiches de paie", expenses: "Notes de frais", leaves: "Congés", premium: "Premium" },
    },
  },
  es: {
    translation: {
      nav: { services: "Servicios", functions: "Funciones", stories: "Historias", pricing: "Precios", faq: "FAQ", demo: "Demo", login: "Acceder", register: "Empezar gratis" },
      hero: { cta_primary: "Prueba 14 días gratis", cta_secondary: "Probar en 60s" },
      common: { loading: "Cargando…", save: "Guardar", cancel: "Cancelar", delete: "Eliminar", confirm: "Confirmar", close: "Cerrar", search: "Buscar", new: "Nuevo", edit: "Editar", back: "Atrás", next: "Siguiente", language: "Idioma" },
      portal: { dashboard: "Panel", checkin: "Fichaje", calendar: "Calendario", chat: "Chat", signatures: "Por firmar", files: "Mis archivos", payslips: "Nóminas", expenses: "Gastos", leaves: "Permisos", premium: "Premium" },
    },
  },
  ro: {
    translation: {
      nav: { services: "Servicii", functions: "Funcții", stories: "Povești", pricing: "Prețuri", faq: "FAQ", demo: "Demo", login: "Autentificare", register: "Start gratuit" },
      hero: { cta_primary: "Încearcă 14 zile gratuit", cta_secondary: "Încearcă în 60s" },
      common: { loading: "Se încarcă…", save: "Salvează", cancel: "Anulează", delete: "Șterge", confirm: "Confirmă", close: "Închide", search: "Caută", new: "Nou", edit: "Editează", back: "Înapoi", next: "Înainte", language: "Limbă" },
      portal: { dashboard: "Tablou", checkin: "Pontaj", calendar: "Calendar", chat: "Chat", signatures: "De semnat", files: "Fișierele mele", payslips: "Fluturași", expenses: "Cheltuieli", leaves: "Concedii", premium: "Premium" },
    },
  },
  ar: {
    translation: {
      nav: { services: "الخدمات", functions: "الوظائف", stories: "القصص", pricing: "الأسعار", faq: "أسئلة", demo: "تجربة", login: "تسجيل الدخول", register: "ابدأ مجانًا" },
      hero: { cta_primary: "جرّب مجانًا 14 يومًا", cta_secondary: "تجربة في 60 ثانية" },
      common: { loading: "جارٍ التحميل…", save: "حفظ", cancel: "إلغاء", delete: "حذف", confirm: "تأكيد", close: "إغلاق", search: "بحث", new: "جديد", edit: "تعديل", back: "رجوع", next: "التالي", language: "اللغة" },
      portal: { dashboard: "اللوحة", checkin: "حضور", calendar: "التقويم", chat: "دردشة", signatures: "للتوقيع", files: "ملفاتي", payslips: "قسائم", expenses: "نفقات", leaves: "إجازات", premium: "بريميوم" },
    },
  },
};

const initial = (() => {
  try {
    return window.localStorage.getItem("verixae:locale") || "it";
  } catch {
    return "it";
  }
})();

i18n.use(initReactI18next).init({
  resources,
  lng: initial,
  fallbackLng: "it",
  interpolation: { escapeValue: false },
});

// RTL support for Arabic
const applyDir = (lng) => {
  try {
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lng;
  } catch {}
};
applyDir(initial);
i18n.on("languageChanged", (lng) => {
  applyDir(lng);
  try { window.localStorage.setItem("verixae:locale", lng); } catch {}
});

export default i18n;
